module.exports = __webpack_public_path__ + "public/img/PMS - Header Banner 2.1f47915d.png";